import React, { useCallback } from 'react'

import { useOffer } from '../../../../hooks/offer'

import { CustomButtom } from '../../../../components/BotaoCTA/styles'

import {
	Wrapper,
	TextIntro,
	TitleContainer,
	Title,
	ContainerCTA,
	Container,
	Content,
	Background
} from './style'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import Loading from 'src/components/Loading'
import { getSection } from 'src/hooks/useContentful/getSection'

export default function Banner() {
	const { currentOffer } = useOffer()
	const { data, isLoading } = useFetchContent()

	const scrollToOffer = useCallback(() => {
		const el = document.querySelector('#plans')
		const yOffset = -80
		const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset

		window.scrollTo({ top: y, behavior: 'smooth' })
	}, [])

	if (isLoading || !data) return <Loading />

	const {
		mensagemBanner,
		bannerMessageColor,
		bannerTitleColor,
		landingTitulo,
		backgroundImagem,
		PrimaryButtonText,
		primaryColorButton,
		primaryButtonTextColor,
		secondaryButtonColor,
		secondaryButtonTextColor,
		secondaryButtonText,
		secondaryBtnBorder,
		hasPrimmaryBtn,
		hasSecondaryBtn
	} = getSection({ sectionName: 'landingHeader', data })
	const bannerBgImage = backgroundImagem.fields.file.url

	const openLink = () => {
		window.open('https://veloe.com.br/sobre', '_blank').focus()
	}

	return (
		<Wrapper>
			<Container>
				<Background src={'https://' + bannerBgImage} />
				<Content>
					{currentOffer && currentOffer.intro ? (
						<TextIntro
							cor={bannerMessageColor}
							tamanho="Grande"
							dangerouslySetInnerHTML={{ __html: currentOffer.intro }}
						/>
					) : (
						<TextIntro cor={bannerMessageColor}>{mensagemBanner}</TextIntro>
					)}
					<TitleContainer>
						<Title tamanho="Medio" cor={bannerTitleColor}>
							{currentOffer && currentOffer.title
								? currentOffer.title
								: landingTitulo}
						</Title>
					</TitleContainer>
					<div>
						{hasPrimmaryBtn === true && (
							<ContainerCTA>
								<CustomButtom
									color="primary"
									label={PrimaryButtonText}
									onBg="light"
									onClick={scrollToOffer}
									style={{
										color: primaryButtonTextColor,
										backgroundColor: primaryColorButton,
										border: undefined
									}}
								/>
							</ContainerCTA>
						)}
						{hasSecondaryBtn === true && (
							<ContainerCTA>
								<CustomButtom
									color="primary"
									label={secondaryButtonText}
									onBg="light"
									onClick={openLink}
									style={{
										backgroundColor: secondaryButtonColor,
										color: secondaryButtonTextColor,
										border: `1px solid ${secondaryBtnBorder}`
									}}
								/>
							</ContainerCTA>
						)}
					</div>
				</Content>
			</Container>
		</Wrapper>
	)
}
